import { fetchFulfillmentCapabilitiesRGD } from './../../queries/store-fulfillment/store-fulfillment'
import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { fetchFulfillmentCapabilities } from 'queries/store-fulfillment/store-fulfillment'
import { FulfillmentCapabilitiesFetchProps } from 'types/api'
import { TIME } from 'utils/misc'
import { format, isToday } from 'date-fns'
import { useAnalytics } from 'utils/analytics'

export const formatCalledAt = (ts?: number, lang = 'en-US') => {
    if (!ts) return undefined
    const d = new Date(ts)
    const dateStr = format(d, 'MMM d, h:mm a')
    const parts = new Intl.DateTimeFormat(lang, {
        timeZoneName: 'short',
    }).formatToParts(d)
    const timeZone = parts.find((p) => p.type === 'timeZoneName')?.value ?? ''

    return {
        formatted: `${dateStr} ${timeZone}`,
        isToday: isToday(d),
    }
}

export function useFulfillmentCapabilities({
    env,
    accessToken,
    locationId,
}: FulfillmentCapabilitiesFetchProps) {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME
    const { data, isLoading, isError, refetch, remove, error, dataUpdatedAt } =
        useQuery(
            [QueryKeys.FULFILLMENT_CAPABILITIES, locationId],
            () =>
                fetchFulfillmentCapabilities({
                    env,
                    accessToken,
                    dynamicSubPath: locationId,
                    trackEvent,
                }),
            {
                enabled: Boolean(env && locationId && accessToken),
                staleTime: tenMinutes,
                cacheTime: tenMinutes,
                retry: false,
            },
        )

    const calledAtData = formatCalledAt(dataUpdatedAt)

    return {
        data,
        isLoading,
        isError,
        refetch,
        remove,
        error,
        calledAt: calledAtData?.formatted,
        isCalledAtToday: calledAtData?.isToday ?? false,
    }
}

export function useFulfillmentCapabilitiesRGD({
    env,
    accessToken,
    locationId,
}: FulfillmentCapabilitiesFetchProps) {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME
    const { data, isLoading, isError, refetch, remove, error, dataUpdatedAt } =
        useQuery(
            [QueryKeys.FULFILLMENT_CAPABILITIES_RGD, locationId],
            () =>
                fetchFulfillmentCapabilitiesRGD({
                    env,
                    accessToken,
                    dynamicSubPath: locationId,
                    trackEvent,
                }),
            {
                enabled: Boolean(env && locationId && accessToken),
                staleTime: tenMinutes,
                cacheTime: tenMinutes,
                retry: false,
            },
        )

    const calledAtData = formatCalledAt(dataUpdatedAt)

    return {
        data,
        isLoading,
        isError,
        refetch,
        remove,
        error,
        calledAt: calledAtData?.formatted,
        isCalledAtToday: calledAtData?.isToday ?? false,
    }
}
